import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

export default function PrintDialog({ open, onClose, templateHtml, onPrint }) {
  const [copies, setCopies] = useState(1);

  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose();
        setCopies(1);
      }}
      aria-labelledby="print-dialog-title"
      //   fullWidth
      maxWidth="md"
    >
      <DialogTitle
        id="print-dialog-title"
        className="custom-dialog-header"
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <div>Print Preview</div>
        <div
          className="dialog-close"
          onClick={() => {
            onClose();
            setCopies(1);
          }}
        >
          <i className="icon-modal-close"></i>
        </div>
      </DialogTitle>

      <DialogContent dividers className="CHA-dialog-content-area">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "#f9f9f9",
            padding: "20px",
          }}
        >
          <div
            className="sticker-preview"
            style={{
              border: "1px solid #ccc",
              borderRadius: "8px",
              background: "#fff",
              padding: "10px",
              //   width: "850px", // match ^PW830
              //   height: "580px", // match ^LL560
              boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            }}
            dangerouslySetInnerHTML={{ __html: templateHtml }}
          />
        </div>

        <label>Copies</label>
        <TextField
          //   label="Copies"
          type="number"
          value={copies}
          onChange={(e) => setCopies(Number(e.target.value))}
          inputProps={{ min: 1 }}
          fullWidth
          style={{ marginTop: "5px" }}
        />
      </DialogContent>

      <DialogActions className="p-p-0 dialog-footer1">
        <Button
          className="primary-btn1"
          onClick={() => {
            onClose();
            setCopies(1);
          }}
        >
          Close
        </Button>
        <Button
          className="primary-btn"
          onClick={() => {
            onPrint(copies); // call Zebra print with chosen copies
            onClose();
            setCopies(1);
          }}
        >
          Print
        </Button>
      </DialogActions>
    </Dialog>
  );
}
